import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from "react-router";
import { FaUser } from 'react-icons/fa';
import firebase, { firebaseAnalytics } from './components/Firebase';
import Filosofi from './components/Filosofi';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Carosello from './components/Carosello';
import Tabelle from './components/Tabelle';
import './styles/Home.css';

export function Home() {
    const refreshPage = () => window.location.reload();

    useEffect(() => {
        firebaseAnalytics.logEvent("homepage_visited")
        firebaseAnalytics.setCurrentScreen("Home")
    }, [])

    return (
        <div className='page-container'>
            <div className="App">
                <div className='sopra'>
                    {firebase.auth().currentUser == null ? 
                        <Link className="accedi" to="/login">
                            Accedi
                            <FaUser className="accedi"/>
                        </Link>
                        : 
                        <a style={{ color: 'rgb(194, 194, 194)' }} className="a" onClick={() => { firebase.auth().signOut(); refreshPage(); }}>
                            <text className="accedi" style={{color: "#c2c2c2"}}>
                                {firebase.auth().currentUser.email}
                                <FaUser className="accedi"/>
                            </text>
                        </a>}
                </div>
                <Filosofi />
                <Carosello />
                <br />
                <Tabelle />
            </div>
            <ScrollToTop />
            <br />
            <Footer />
        </div>
    );
};

